import { MutationKey } from './MutationKey';

const DETAILS = 'details';
const GRID = 'grid';
const CHART = 'chart';
const LOGS = 'logs';

export class QueryKey {
  entityKey: any[];

  constructor(...key: any[]) {
    this.entityKey = key;
  }

  all(...key: (string | undefined)[]) {
    return [...this.entityKey, ...key];
  }

  details() {
    return this.next(DETAILS);
  }

  logs() {
    return this.next(LOGS);
  }

  //When we need to pass more than 1 key, as we do in AT/CT for chart, annotations etc
  exact(...key: string[]) {
    return (prop?: any) => {
      if (prop) {
        return [...this.all(), ...key, prop];
      } else {
        return [...this.all(), ...key];
      }
    };
  }

  grid() {
    return (params: any) => [...this.grids(), params];
  }

  grids() {
    return this.all(GRID);
  }

  chart() {
    return this.exact(CHART);
  }

  mutations() {
    return new MutationKey(...this.entityKey);
  }

  next(...key: string[]) {
    return (id: any) => {
      return [...this.all(), id, ...key];
    };
  }

  query(key: any) {
    return new QueryKey(...this.entityKey, key);
  }
}
